module.exports = __webpack_public_path__ + "static/media/wardah.fa541dff.png";